import React, { useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2, ImageIcon } from "lucide-react";
import { CompanyLogo } from "@/components/TeamBadge";

export const CompanyLogoCard = ({ company, onChange }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/company/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.logo_url);
      toast.success("Logo updated — it now shows on your team badge");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async () => {
    if (!window.confirm("Remove your company logo?")) return;
    try { await api.delete("/company/logo"); onChange(""); toast.success("Logo removed"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="card-soft" data-testid="company-logo-card">
      <h2 className="font-heading text-xl text-[#1E3F33] mb-1 flex items-center gap-2"><ImageIcon className="w-4 h-4 text-[#2D6A4F]"/> Company logo</h2>
      <p className="text-xs text-[#8A9A86] mb-4">Shown on your "Part of {company.company_name}" team badge when one of your collectors contacts a customer. Collectors without their own photo use it as their picture. PNG, JPG or WEBP, up to 5MB.</p>
      <div className="flex items-center gap-4 flex-wrap">
        <CompanyLogo logo={company.logo_url} name={company.company_name} size="w-20 h-20" testid="company-logo-preview" />
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid="company-logo-input" onChange={(e) => upload(e.target.files?.[0])} />
        <div className="flex flex-wrap gap-2">
          <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid="company-logo-upload" className="btn-secondary text-sm inline-flex items-center gap-2"><Upload className="w-4 h-4"/> {busy ? "Uploading…" : company.logo_url ? "Replace logo" : "Upload logo"}</button>
          {company.logo_url && <button type="button" onClick={remove} data-testid="company-logo-remove" className="text-sm text-[#8A9A86] hover:text-[#E63946] inline-flex items-center gap-1.5"><Trash2 className="w-4 h-4"/> Remove</button>}
        </div>
      </div>
    </div>
  );
};
